<template>
  <coverage-page 
    :customPageControl="pageControl"
    :customNeedValidate="needValidate"
  />
</template>
<script>
import { mapGetters } from "vuex";
import CoveragePage from "./components/CoveragePage.vue";
import { commonMixin } from "@/mixins/common";
export default {
  mixins: [commonMixin],
  name: "MedicalExpenseLimit",
  components: {
    CoveragePage,
  },
  data() {
    return {
      pageControl: {
        pageName: "醫療限額",
        pageBlock: ["period", "formula", "maxCustom"],
        showUpper: true,
      }, 
      needValidate: {
        period_upper: false,
      },
    };
  },
  computed: {
    ...mapGetters(["BaseUrl"]),
  },
  watch: {},
  methods: {},
  mounted() {},
};
</script>
